<template>
  <Grid gaf="column" justify-content="space-between" align-items="center" class="opaque-header q-pl-xl q-pr-lg q-py-sm">
    <div class="text-subtitle-2 text-secondary-2">
      Email Outbox
    </div>

    <Grid gaf="column" gap="var(--r-space-md)" align-items="center">
      <ExportBtn :loading="exportLoading" @click="$emit('export')" />

      <ShowHideCols :ag-grid="agGrid" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import ExportBtn from '@/reusable/ExportBtn'

export default {
  components: {
    ShowHideCols,
    ExportBtn
  },

  props: {
    agGrid: Object
  },

  computed: {
    ...mapState('lv-emails', ['exportLoading'])
  }
}
</script>
